export class CertificatesMentorat {
  constructor(
    public name: string,
    public shortname: string,
    public fullname: string,
    public certificateCode: string,
    public description: string,
    public plateforme: string,
    public createdBy?: string
  ) {}
}
